import styled from 'styled-components';

import HtmlContent from '@telialt/common-html-content/src';
import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const ESimNoticeContainer = styled.div`
    border-top: 1px solid ${getPurpurColor('gray200')};
    padding-top: ${getPurpurSpacing('600')};
    padding-bottom: ${getPurpurSpacing('600')};
`;

export const ESimNoticeContent = styled(HtmlContent)`
    background: ${getPurpurColor('gray50')};
    padding: ${getPurpurSpacing('250')};
    font-size: ${getPurpurTypography('scale75')};
`;
